/* eslint-disable react/forbid-component-props */
import React, { useState, useEffect } from 'react'
import { Container, Typography, Box, LinearProgress } from '@mui/material'
import { Link as NavigateLink, Link } from 'react-router-dom'
import GuideLayout from './GuideLayout'
import { useAuth } from '../../../contexts/AuthContext'
import CanineCareGuide from './Pages/CanineCareGuide'

const CanineCare = () => {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const { currentUser } = useAuth()

  useEffect(() => {
    setUser(currentUser)
    setLoading(false)
  }, [currentUser])

  return (
    <section>
      <Container fixed sx={{ marginTop: '50px' }}>
        <Typography mb={6} variant="h4">
          Training Guide
        </Typography>
        <NavigateLink to="/members">{'< Back to Members Area'}</NavigateLink>
        <Box sx={{ marginTop: 5 }}>
          {!!loading && <LinearProgress color="primary" />}
          <GuideLayout
            watermark={`Licensed to ${user?.firstName} ${user?.lastName}`}
          >
            <Box>
              <Typography align="center" mb={3}>
                PADs In Training Guide
              </Typography>
              <Typography variant="h4" align="center" mb={3}>
                Table of Contents
              </Typography>

              <Box
                component="ul"
                sx={{ pl: 3, listStyle: 'none', p: 0, m: 0, mb: 5 }}
              >
                <li style={{ listStyle: 'none', marginBottom: 10 }}>
                  <a href="#canine-care">3. Canine Care</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#daily-routines">Daily Routines</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#weekly-routines">Weekly Routines</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#monthly-routines">Monthly Routines</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#vet-checks">Annual Vet Check</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#fear-free-handling">Fear free handling</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#equipment">Equipment</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#nutrition">Nutrition</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#environment">Environment</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#enrichment">Canine Enrichment</a>
                </li>
                <li style={{ listStyle: 'none', marginBottom: 10, marginLeft: 20 }}>
                  <a href="#dog-handler">The Dog/Handler Partnership</a>
                </li>
              </Box>
            </Box>
            <CanineCareGuide />
          </GuideLayout>
        </Box>
      </Container>
    </section>
  )
}

export default CanineCare
